<script setup>
import bgSmile from '@/assets/img/bg-smilepicture.png'
import t1 from '@/assets/img/art-board.png'

const cards = [
    { title: 'Brand Campaign Video', role: 'Build strong brand presence through impactful visual storytelling.', img: t1 },
    { title: 'Promotional & Seasonal Campaign Video', role: 'Engaging videos designed for promotions, launches, and special moments.', img: t1 },
    { title: 'Social & Digital Campaign Video', role: 'Short-form, dynamic content tailored for digital and social platforms.', img: t1 },
    { title: 'Corporate & Institutional Campaign', role: 'Professional campaign videos for corporate messaging and institutional needs.', img: t1 },
]
</script>

<template>
    <section class="wrapper" :style="{
        backgroundImage: `url(${bgSmile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    }">
        <div class="container py-14 py-md-16">
            <div class="row mb-3">
                <div class="col-md-10 col-lg-12 col-xl-10 col-xxl-9 mx-auto text-center">
                    <h3 class="display-4 mb-7 px-lg-19 px-xl-18 text-white">
                        Types of <span class="text-secondary">Campaign Video</span>
                    </h3>
                </div>
            </div>

            <div class="row gx-4 gy-8 align-items-stretch">
                <div class="col-md-6 col-lg-3" v-for="(card, index) in cards" :key="index">
                    <div class="card h-100 border-transparent shadow-none d-flex flex-column">
                        <figure class="card-img-top ratio-4-3 overflow-hidden rounded">
                            <img class="img-fluid w-100 h-100 object-cover" :src="card.img" alt="" />
                        </figure>
                        <div class="card-body d-flex flex-column text-center flex-grow-1">
                            <h4 class="text-secondary mb-2">{{ card.title }}</h4>
                            <p class="mb-0 text-white flex-grow-1">{{ card.role }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.ratio-4-3 {
    aspect-ratio: 4 / 3;
}

.object-cover {
    object-fit: cover;
}

.card {
    background-color: transparent;
    border: none;
}

.card-body {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
</style>
